import { Component, inject } from '@angular/core';
import {ClientService} from '../../../client/client.service';
import {Observable, Subject} from 'rxjs';
import {Client} from '../../../client/client';
import {tap} from 'rxjs/operators';
import {Router} from '@angular/router';
import {Page} from '../../../core/pagination/page';
import {ClientPageRequest} from '../../../client/client-page-request';
import {SortOrder} from '../../../core/sort/sort-order';

@Component({
    templateUrl: './zoek-client.page.html',
    styleUrls: ['./zoek-client.page.scss'],
    standalone: false
})
export class ZoekClientPage {
  private clientService = inject(ClientService);
  private router = inject(Router);

  initialPageRequest: ClientPageRequest = ClientPageRequest.firstClientenPageRequest(SortOrder.ASCENDING, 5)
  clientenPage$: Subject<Page<Client>> = new Subject<Page<Client>>();
  private currentPageRequest: ClientPageRequest;

  navigateToClient(client: Client): void {
    this.router.navigateByUrl(`/clienten/${client.getId()}`);
  }

  onPageChange(pageRequest: ClientPageRequest): void {
    this.getClienten$(pageRequest).subscribe();
  }

  private getClienten$(pageRequest: ClientPageRequest): Observable<Page<Client>> {
    this.currentPageRequest = pageRequest;
    return this.clientService
      .getClienten$(pageRequest)
      .pipe(tap(page => this.clientenPage$.next(page)));
  }
}
